import {Box, List, Paper, Stack, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";

import SystemSecurityUpdateGoodIcon from '@mui/icons-material/SystemSecurityUpdateGood';
import ScreenLockPortraitIcon from '@mui/icons-material/ScreenLockPortrait';

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import CancelMfaSignInButton from "../../../../common/CancelMfaSignInButton";
import {AuthenticationHandler, useAuthenticate} from "../../useAuthenticate";
import {AuthenticationContext} from "../../AuthenticateView";
import {useLxTranslations} from "@lxo-blocks/react";
import {METHODS_VIEW_TRANSLATION} from "./MethodsView.translation.de";
import ErrorBanner from "../../../../common/ErrorBanner";
import MethodListItemButton from "./components/MethodListItemButton";
import {Methods} from "./types";

interface ChangeMethodProps {
    authenticationHandler: AuthenticationHandler,
    mfaMethods: string[]
}

export default function MethodsView(props: ChangeMethodProps) {
    const {t, LxTrans} = useLxTranslations(METHODS_VIEW_TRANSLATION);
    const {authenticate, authenticationError} = useAuthenticate(props.authenticationHandler);
    const authenticationContext = useContext(AuthenticationContext)
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [submittingMethod, setSubmittingMethod] = useState<string | undefined>()

    useEffect(() => {
        if (authenticationError) {
            setIsSubmitting(false)
            setSubmittingMethod(undefined)
        } // eslint-disable-next-line
    }, [authenticationError]);


    const authenticateWithMfa = async (chosenMethod: string) => {
        setSubmittingMethod(chosenMethod)
        setIsSubmitting(true)
        authenticate({...authenticationContext, mfaMethod: chosenMethod});
    }

    const mailToSupport = () => {
        window.location.href = "mailto:info@lexoffice.de?subject=Probleme%20bei%20der%20Zwei%20Faktor%20Authentifizierung";
        setSubmittingMethod("METHOD_HELP")
        setIsSubmitting(true)

        setTimeout(() => {
            setSubmittingMethod(undefined)
            setIsSubmitting(false)
        }, 5000)
    };


    return (
        <>
            <Paper sx={{pr: 2, pl: 2, pt: 2}}>
                {authenticationError && (
                    <ErrorBanner headline={t("ERROR_HEADLINE")}
                                 description={authenticationError.description
                                     ? authenticationError.description
                                     : t("ERROR_TEXT")}
                                 sx={{mb: 3}}/>)}
                <Box>
                    <Typography className="Title" variant="body2" sx={{pb: 2}}>
                        <LxTrans
                            i18nKey={"HEADLINE"} components={{bold: <strong/>}}/>
                    </Typography>
                </Box>

                <List component="nav">
                    {props.mfaMethods.includes(Methods.MOBILEPUSH) && (<>
                        <MethodListItemButton text={t("METHOD_MFAPUSH")}
                                              onClick={() => authenticateWithMfa(Methods.MOBILEPUSH)}
                                              icon={<SystemSecurityUpdateGoodIcon/>}
                                              isSubmitting={submittingMethod === Methods.MOBILEPUSH}
                                              disabled={isSubmitting}/>
                    </>)}
                    {props.mfaMethods.includes(Methods.TOTP) && (<>
                        <MethodListItemButton text={t("METHOD_TOTP")}
                                              onClick={() => authenticateWithMfa(Methods.TOTP)}
                                              icon={<ScreenLockPortraitIcon/>}
                                              isSubmitting={submittingMethod === Methods.TOTP}
                                              disabled={isSubmitting}/>
                    </>)}
                    <MethodListItemButton text={t("METHOD_RECOVERYCODE")}
                                          onClick={() => props.authenticationHandler.onResetMfa()}
                                          icon={<DeleteForeverIcon/>}
                                          isSubmitting={submittingMethod === "METHOD_RECOVERYCODE"}
                                          disabled={isSubmitting}/>

                    <MethodListItemButton
                        text={t("METHOD_HELP")}
                        onClick={mailToSupport}
                        icon={<HelpOutlineIcon/>}
                        isSubmitting={submittingMethod === "METHOD_HELP"}
                        disabled={isSubmitting}/>
                </List>
            </Paper>

            <Stack spacing={2} direction="row-reverse" style={{float: "right"}} mt={1}>
                <CancelMfaSignInButton/>
            </Stack>
        </>
    );
}
